import initLpuLoyaltyProgram from 'src/components/common/LpuLoyaltyProgram'

initLpuLoyaltyProgram()
